var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Merry Christmas!")]),_c('h2',[_vm._v("For the 5th time ♥")]),_c('div',{staticClass:"cards-wrapper"},[_c('ul',{staticClass:"cards"},_vm._l((_vm.range(1,24)),function(i){return _c('li',{key:i,staticClass:"card"},[_c('div',[_c('router-link',{attrs:{"to":'/2019/day/' + i}},[_vm._v(" "+_vm._s(i)+" ")])],1)])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }